import { createAppKit } from "@reown/appkit/vue";
import {
  mainnet,
  polygon,
  base,
  solana,
  solanaTestnet,
  solanaDevnet,
  type AppKitNetwork,
} from "@reown/appkit/networks";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { SolanaAdapter } from "@reown/appkit-adapter-solana";
import { WagmiPlugin } from "@wagmi/vue";
import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";

// Using type assertion to handle version conflicts between AppKit's bundled Viem and project Viem
const networks = [
  mainnet,
  polygon,
  base,
  solana,
  solanaTestnet,
  solanaDevnet,
] as [AppKitNetwork, ...AppKitNetwork[]];

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const projectId = config.public.REOWN_PROJECT_ID;

  if (!projectId) {
    throw new Error("REOWN_PROJECT_ID is not set");
  }

  const solanaAdapter = new SolanaAdapter();
  const wagmiAdapter = new WagmiAdapter({
    networks,
    projectId,
  });

  // Register Wagmi plugin (required for Wagmi to work properly)
  nuxtApp.vueApp.use(WagmiPlugin, { config: wagmiAdapter.wagmiConfig });

  // Wallet IDs from https://walletguide.walletconnect.network/
  const metamaskWalletId =
    "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96";
  const trustWalletId =
    "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0";
  const phantomWalletId =
    "a797aa35c0fadbfc1a53e7f675162ed5226968b44a19ee3d24385c64d1d3c393";

  const url = config.public.WHITELISTED_DOMAINS[0];

  // Initialize AppKit once at app startup
  createAppKit({
    adapters: [wagmiAdapter, solanaAdapter],
    networks,
    projectId,
    metadata: {
      name: "Evangelist",
      description: "Connect your wallet to Evangelist",
      url,
      icons: [],
    },
    features: {
      email: false,
      socials: false,
      analytics: false,
    },
    themeMode: "light",
    allWallets: "SHOW",
    featuredWalletIds: [phantomWalletId, metamaskWalletId, trustWalletId],
  });
});
